const IGNORED_KEYS = ['app'];

const normalize = value => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') return String(value);
  if (Array.isArray(value)) return value.map(normalize);
  if (typeof value === 'object') {
    return Object.keys(value)
      .filter(key => !IGNORED_KEYS.includes(key))
      .sort()
      .reduce((acc, key) => {
        acc[key] = normalize(value[key]);
        return acc;
      }, {});
  }
  return value;
};

export const serializeForComparison = value => {
  if (value === null || value === undefined) return null;
  try {
    return JSON.stringify(normalize(value));
  } catch (error) {
    return null;
  }
};

export default serializeForComparison;
